import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'Bot',

  // model
  botModel: [],
  serviceModel: [],
  
  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {botParams, serviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'bot',
          'service'
        ],
        [
          'v1BotListGet',
          'v1ServiceListGet'
        ],
        [
          botParams,
          serviceParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setBotModel', res[0].data.bots)
            commit('setServiceModel', res[1].data.serviceInfo)
            console.log('botModel', state.botModel)
            console.log('serviceModel', state.serviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.botUuid)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setBotModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'botModel', data)
  },
  setServiceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpBotName', null)
    Vue.set(state.values, 'inpBotUrl', null)
    Vue.set(state.values, 'inpMailAddress', null)
    Vue.set(state.values, 'inpPassword', null)
    Vue.set(state.values, 'inpBotKbn', '')
    Vue.set(state.values, 'inpServiceId', '')
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpBotName', data.botName)
    Vue.set(state.values, 'inpBotUrl', data.botUrl)
    Vue.set(state.values, 'inpMailAddress', data.botEmail)
    Vue.set(state.values, 'inpPassword', data.botPassword)
    Vue.set(state.values, 'inpBotKbn', data.botKbn || '')
    Vue.set(state.values, 'inpServiceId', data.service.serviceUuid)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
